import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import {LatLng} from 'leaflet';

import {Vehicle} from '../../../../commons/models/domain/Vehicle';
import {Config} from '../../../../commons/models/domain/Config';
import {VehicleControlIndicator} from '../../../../commons/models/domain/VehicleControlIndicator';
import {Driver} from '../../../../commons/models/domain/Driver';
import {MapService} from '@commons/services/map/map/map.service';
import {MapConfigService} from '@commons/services/map/config/map-config.service';
import {Subscription} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'tk-vehicle-list-full-item',
    templateUrl: './vehicle-list-full-item.component.html',
    styleUrls: ['./vehicle-list-full-item.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class VehicleListFullItemComponent implements OnInit, OnChanges, OnDestroy {

    private vehicleValue? : Vehicle;

    @Input()
    public set vehicle(value)
    {
      this.vehicleValue = new Vehicle(value, this.translate);
    }

    public get vehicle(): Vehicle
    {
      return this.vehicleValue!;
    }

    @Input()
    public isScrolling?: boolean;

    @Output()
    public onItemDataChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    public index?: number;

    @Input()
    public isSelected?: boolean;

    @Input()
    public config?: Config;

    @Input()
    public options: any;

    @Input()
    public isIndictorColumnFullOn?: boolean;

    @Input()
    public indictorColumnFullMinWidth?: number;

    @Input()
    public indictorColumnFullLeft?: number;


    /**
     * parametry
     */
    public params?: VehicleControlIndicator[];

    /**
* obserwacja zmian
*/
    private vehicleChangeSub?: Subscription;

    /* śledzenie */
    private isFirstZoom = true;

    /**
     * kierowca
     */
    public driver?: Driver;

    public fuel?: VehicleControlIndicator;

    private timeout: any;

    /**
     * konstruktor
     */
    constructor(
        private $map: MapService,
        private $mapConfig: MapConfigService,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.params = this.vehicle.ControlIndicators;
        this.driver = this.vehicle.LastDriver;
        this.fuel = this.vehicle.mainFuel;
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes && changes['vehicle']) {
            const vehicle = new Vehicle(changes['vehicle'].currentValue, this.translate);

            this.params = vehicle.ControlIndicators;
            this.driver = vehicle.LastDriver;
            this.fuel = vehicle.mainFuel;

            if (vehicle && this.params) {
                // czujniki
                const indicators = this.params.filter(i => [9, 16, 19, 26].indexOf(i.Tp) !== -1);
                this.onItemDataChange.emit(indicators);
            }

            if (vehicle && this.isSelected) {
                let selVehicleId = this.$mapConfig.getCurrentVehicleId();
                this.isFirstZoom = (!selVehicleId || selVehicleId != vehicle.Id);
                if (this.isFirstZoom) {
                    this.$mapConfig.setCurrentVehicleId('tk-vehicle-list-full-item', vehicle.Id);
                }
                this.goToVehicleLocation('vehicle -> list-full-item -> OnChanges');
            }
        }
    }

    goToVehicleLocation(source: string) {
        if (this.vehicle && this.vehicle.LL) {

                const lat = parseFloat(this.vehicle.LL.Lt + '');
                const lng = parseFloat(this.vehicle.LL.Ln + '');

                if (lat && lat !== 361 && lng && lng !== 361) {
                    const coords = new LatLng(lat, lng);
                    this.$map.showPointWithZoom(coords);
                    this.isFirstZoom = false;
                }
            }
    }

    ngOnDestroy(): void {
        // odwiazanie ewentualnej istniejacje
        if (this.vehicleChangeSub) {
            this.vehicleChangeSub.unsubscribe();
        }
    }

    /**
     * pokazanie kolumny
     * @param type kolumna
     */
    public showColumn(type: number): boolean {
        if (this.config && this.config.VehicleFullListColumns.indexOf(type) !== -1) {
            return true;
        }
        return false;
    }

    /**
 * pokazywanie kolumn tacho
 */
    public showTachoColumn(val?: string): boolean {
        if (!this.options || !this.options.tachoValue) {
            return true;
        }
        if (!val) {
            return this.options.tachoValue.length === 0;
        }
        return this.options.tachoValue.indexOf(val) !== -1;
    }

}
